import { render } from "./RemarksMsg.vue?vue&type=template&id=96808f2a&scoped=true&ts=true"
import script from "./RemarksMsg.vue?vue&type=script&lang=ts"
export * from "./RemarksMsg.vue?vue&type=script&lang=ts"

import "./RemarksMsg.vue?vue&type=style&index=0&id=96808f2a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96808f2a"]])

export default __exports__